import Highway from '@dogstudio/highway';
import { mouseMovefn } from 'utils.js';
import gsap from "gsap";
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

export default class valeursRenderer extends Highway.Renderer {

	onEnter() {

		this.DOM = { view: this.wrap.lastElementChild };
		this.DOM.peopleSwiperContainer = this.DOM.view.querySelector(".people__swiper");

		// Elements for pinning word
		this.DOM.pinningContainer = this.DOM.view.querySelector("#pinning-container");
		this.DOM.values = this.DOM.view.querySelector(".values");
		this.DOM.valuesContainer = this.DOM.view.querySelector(".values .container");
		this.DOM.together = this.DOM.view.querySelector(".together");
		this.DOM.hugeWord = this.DOM.view.querySelector(".huge-word");

		this.pinningWorldST;

		// this.initSwiper();
	}

	onEnterCompleted() {
		this.pinningWord();
	}

	// initSwiper() {
	// 	this.swiperHumanRights = new Swiper(this.DOM.peopleSwiperContainer, {
	// 		id: "Pining-Word",
	// 		autoplay: {
	// 			delay: 1000,
	// 			reverseDirection: true,
	// 		},
	// 		speed: 1000,
	// 		loop: true,
	// 		slidesPerView: "auto",
	// 		grabCursor: true,
	// 		spaceBetween: 20,
	// 		breakpoints: {
	// 			768: {
	// 				spaceBetween: 50
	// 			}
	// 		},
	// 	});
	// }

	pinningWord() {
		// Only pining word
		this.pinningWorldST = ScrollTrigger.create({
			id: "",
			trigger: this.DOM.pinningContainer,
			endTrigger: this.DOM.together.querySelector(".people__swiper"),
			start: "top 0%",
			end: "top 50%",
			pin: this.DOM.hugeWord,
			onRefresh: self => self.pin.parentNode.style.float = "left",
			pinSpacing: false,
			// markers: {startColor: "#b2bec3", endColor: "#2d3436", fontSize: "15px"}
		});

		// Change color when hovering "together" section
		this.hugeWordChangeColorTl = gsap.timeline({
			scrollTrigger: {
				trigger: this.DOM.together,
				start: "top 50%",
				end: "bottom 70%",
				scrub: true,
				toggleActions: "play pause resume reset",
				markers: false
			}
		});

		this.hugeWordChangeColorTl.to(this.DOM.hugeWord, {
			color: "#ffffff",
			opacity: 1,
		});
	}

	onLeaveCompleted() {
		// Kill the ScrollTrigger
		this.pinningWorldST.kill();
		// Kill the timeline
		this.hugeWordChangeColorTl.scrollTrigger.kill();
	}
}
